import { FULL_WIDTH, GAME_FACT_BASKET_COMMENT, GAME_FACT_BASKET_FAULT, GAME_FACT_BASKET_FREETHROW, GAME_FACT_BASKET_STAR, GAME_FACT_BASKET_STOP, GAME_FACT_BASKET_TECHNICAL, GAME_FACT_BASKET_THREEPOINTS, GAME_FACT_BASKET_TIMEOUT, GAME_FACT_BASKET_TWOPOINTS, GAME_FACT_COMMENT, GAME_FACT_DROP, GAME_FACT_ESSAI, GAME_FACT_FAULT, GAME_FACT_HANDBALL_GOAL, GAME_FACT_HANDBALL_PENALTY, GAME_FACT_HANDBALL_REDCARD, GAME_FACT_HANDBALL_SHOOTOUT, GAME_FACT_HANDBALL_STAR, GAME_FACT_HANDBALL_STOP, GAME_FACT_HANDBALL_TIMEOUT, GAME_FACT_HANDBALL_TURNOVER, GAME_FACT_HANDBALL_TWOMIN_SUSPENSION, GAME_FACT_HANDBALL_YELLOWCARD, GAME_FACT_PENALITE, GAME_FACT_REDCARD, GAME_FACT_REPLACEMENT, GAME_FACT_RUGBY_STAR, GAME_FACT_RUGBY_STOP, GAME_FACT_SHOOTOUTPENALTY, GAME_FACT_SOCCER_BUT, GAME_FACT_SOCCER_COMMENT, GAME_FACT_SOCCER_FAULT, GAME_FACT_SOCCER_PENALTY, GAME_FACT_SOCCER_REDCARD, GAME_FACT_SOCCER_REPLACEMENT, GAME_FACT_SOCCER_SECONDYELLOWCARD, GAME_FACT_SOCCER_SHOOTOUTPENALTY, GAME_FACT_SOCCER_SHOT, GAME_FACT_SOCCER_STAR, GAME_FACT_SOCCER_STOP, GAME_FACT_SOCCER_YELLOWCARD, GAME_FACT_START, GAME_FACT_TRANSFORMATION, GAME_FACT_YELLOWCARD, MEDIA_ARTICLE, MEDIA_NOTATION, MEDIA_QUESTIONBOX, MEDIA_QUIZZ, MEDIA_SURVEY } from "./constants.js";

import but_img from '../../../../../images/live/icones/live_but.png'
import tir_img from '../../../../../images/live/icones/live_tir.png'
import penalty_img from '../../../../../images/live/icones/live_penalty.png'
import soccer_tiraubut_img from '../../../../../images/live/icones/live_penalty.png'
import soccer_fault_img from '../../../../../images/live/icones/live_faute.png'

import essai_img from '../../../../../images/live/icones/live_essai.png'
import transformation_img from '../../../../../images/live/icones/live_transformation.png'
import drop_img from '../../../../../images/live/icones/live_drop.png'
import penalite_img from '../../../../../images/live/icones/live_penalite.png'

import but_hand_img from '../../../../../images/live/icones/live_but_hand.png'
import balle_perdue_hand_img from '../../../../../images/live/icones/live_balle_perdue_hand.png'
import exclusion_hand_img from '../../../../../images/live/icones/live_exclusion_hand.png'
import penalty_hand_img from '../../../../../images/live/icones/live_penalty_hand.png'
import temps_mort_hand_img from '../../../../../images/live/icones/live_temps_mort_hand.png'

import basket_faute_technique_img from '../../../../../images/live/icones/basket_faute_technique.png'
import basket_faute_img from '../../../../../images/live/icones/basket_faute.png'
import basket_lancer_franc_1pts_img from '../../../../../images/live/icones/basket_lancer_franc_1pts.png'
import basket_lancer_franc_2pts_img from '../../../../../images/live/icones/basket_lancer_franc_2pts.png'
import basket_lancer_franc_3pts_img from '../../../../../images/live/icones/basket_lancer_franc_3pts.png'
import basket_temps_mort_img from '../../../../../images/live/icones/basket_temps_mort.png'

import star_img from './icons/generic/star.png'
import yellow_img from '../../../../../images/live/icones/live_cartonjaune.png'
import red_img from '../../../../../images/live/icones/live_cartonrouge.png'
import changement_img from '../../../../../images/live/icones/live_changement.png'
import commentaire_img from '../../../../../images/live/icones/live_commentaire.png'

import SelectPeriodTimer from '../form/parts/SelectPeriodTimer.js';
import SelectTitleComment from "../form/parts/SelectTitleComment.js";
import SelectTeam from "../form/parts/SelectTeam.js";
import SelectPlayer from "../form/parts/SelectPlayer.js";
import SelectCusto from "../form/parts/SelectCusto.js";
import EditorQuill from "../form/parts/EditorQuill.js";
import SelectNotation from "../form/parts/SelectNotation.js";
import SelectSurveyQuestion from "../form/parts/SelectSurveyQuestion.js";
import SelectSurveyChoices from "../form/parts/SelectSurveyChoices.js";
import SelectSurveyOptions from "../form/parts/SelectSurveyOptions.js";
import SelectQuizzQuestion from "../form/parts/SelectQuizzQuestion.js";
import SelectQuizzChoices from "../form/parts/SelectQuizzChoices.js";
import SelectQuizzOptions from "../form/parts/SelectQuizzOptions.js";
import CheckPin from "../form/parts/CheckPin.js";
import Preview from "../form/parts/Preview.js";
import SelectTags from "../form/parts/SelectTags.js";
import SelectQuestionBoxLabel from "../form/parts/SelectQuestionBoxLabel.js";


//////////////////////////////  SVGs /////////////////////////////////////////
/// GAMEFACTS ///
import picto_but from '../../../../../images/picto/standard/but.svg';
import picto_but_blue from '../../../../../images/picto/blue/but_bleu.svg';

import picto_carton_jaune from '../../../../../images/picto/standard/carton_jaune.svg';
import picto_carton_jaune_blue from '../../../../../images/picto/blue/carton_jaune_bleu.svg';

import picto_carton_rouge from '../../../../../images/picto/standard/carton_rouge.svg';
import picto_carton_rouge_blue from '../../../../../images/picto/blue/carton_rouge_bleu.svg';

import picto_changement from '../../../../../images/picto/standard/changement.svg';
import picto_changement_blue from '../../../../../images/picto/blue/changement_bleu.svg';

import picto_etoile from '../../../../../images/picto/standard/etoile.svg';
import picto_etoile_blue from '../../../../../images/picto/blue/etoile_bleu.svg';

import picto_faute from '../../../../../images/picto/standard/faute.svg';
import picto_faute_blue from '../../../../../images/picto/blue/faute_bleu.svg';

import picto_penalty from '../../../../../images/picto/standard/penalty.svg';
import picto_penalty_blue from '../../../../../images/picto/blue/penalty_bleu.svg';

import picto_tir from '../../../../../images/picto/standard/tir.svg';
import picto_tir_blue from '../../../../../images/picto/blue/tir_bleu.svg';

import picto_2_pts from '../../../../../images/picto/standard/2_points_basket.svg';
import picto_2_pts_blue from '../../../../../images/picto/blue/2_points_basket.svg';

import picto_3_pts from '../../../../../images/picto/standard/3_points_basket.svg';
import picto_3_pts_blue from '../../../../../images/picto/blue/3_points_basket.svg';

import picto_balle_perdue from '../../../../../images/picto/standard/balle_perdu_hand.svg';
import picto_balle_perdue_blue from '../../../../../images/picto/blue/balle_perdu_hand.svg';

import picto_tir_au_but_hand from '../../../../../images/picto/standard/tir_au_but_hand.svg';
import picto_tir_au_but_hand_blue from '../../../../../images/picto/blue/tir_au_but_hand_bleu.svg';

import picto_but_hand from '../../../../../images/picto/standard/but_hand.svg';
import picto_but_hand_blue from '../../../../../images/picto/blue/but_hand_bleu.svg';

import picto_drop from '../../../../../images/picto/standard/drop_rugby.svg';
import picto_drop_blue from '../../../../../images/picto/blue/drop_rugby.svg';

import picto_essai from '../../../../../images/picto/standard/essai_rugby.svg';
import picto_essai_blue from '../../../../../images/picto/blue/essai_rugby.svg';

import picto_exclusion from '../../../../../images/picto/standard/exclusion_hand.svg';
import picto_exclusion_blue from '../../../../../images/picto/blue/exclusion_hand.svg';

import picto_faute_technique from '../../../../../images/picto/standard/faute_technique_basket.svg';
import picto_faute_technique_blue from '../../../../../images/picto/blue/faute_technique_basket.svg';

import picto_lancer_franc from '../../../../../images/picto/standard/lancer_franc_basket.svg';
import picto_lancer_franc_blue from '../../../../../images/picto/blue/lancer_franc_basket.svg';

import picto_penality_rugby from '../../../../../images/picto/standard/Penalite_rugby.svg';
import picto_penality_rugby_blue from '../../../../../images/picto/blue/Penalite_rugby.svg';

import picto_temps_mort_basket from '../../../../../images/picto/standard/temps_mort_basket.svg';
import picto_temps_mort_basket_blue from '../../../../../images/picto/blue/temps_mort_basket.svg';

import picto_temps_mort_hand from '../../../../../images/picto/standard/temps_mort_Hand.svg';
import picto_temps_mort_hand_blue from '../../../../../images/picto/blue/temps_mort_Hand.svg';

import picto_transformation_rugby from '../../../../../images/picto/standard/Transformation_rugby.svg';
import picto_transformation_rugby_blue from '../../../../../images/picto/blue/Transformation_rugby.svg';

import picto_tir_au_but_rugby from '../../../../../images/picto/standard/tir_au_but_rugby.svg';
import picto_tir_au_but_rugby_blue from '../../../../../images/picto/blue/tir_au_but_rugby_bleu.svg';


/// OTHERS ///
import picto_article from '../../../../../images/picto/standard/article.svg';
import picto_article_blue from '../../../../../images/picto/blue/article_bleu.svg';

import picto_commentaire from '../../../../../images/picto/standard/commentaire.svg';
import picto_commentaire_blue from '../../../../../images/picto/blue/commentaire_bleu.svg';

import picto_iframe from '../../../../../images/picto/standard/iframe.svg';
import picto_iframe_blue from '../../../../../images/picto/blue/iframe_bleu.svg';

import picto_fb from '../../../../../images/picto/standard/facebook-fb-social-icon.svg';
import picto_fb_blue from '../../../../../images/picto/blue/facebook-fb-social-icon_bleu.svg';

import picto_instagram from '../../../../../images/picto/standard/instagram.svg';
import picto_instagram_blue from '../../../../../images/picto/blue/instagram_bleu.svg';

import picto_notation from '../../../../../images/picto/standard/notation.svg';
import picto_notation_blue from '../../../../../images/picto/blue/notation_bleu.svg';

import picto_quiz from '../../../../../images/picto/standard/quiz.svg';
import picto_quiz_blue from '../../../../../images/picto/blue/quiz_bleu.svg';

import picto_sondage from '../../../../../images/picto/standard/sondage.svg';
import picto_sondage_blue from '../../../../../images/picto/blue/sondage_bleu.svg';

import picto_image from '../../../../../images/picto/standard/import_image.svg';
import picto_image_blue from '../../../../../images/picto/blue/import_image_bleu.svg';

import picto_question_box from '../../../../../images/picto/standard/boite_a_question.svg';
import picto_question_box_blue from '../../../../../images/picto/blue/boite_a_question_bleu.svg';

import picto_x_twitter from '../../../../../images/picto/standard/x_twitter.svg';
import picto_x_twitter_blue from '../../../../../images/picto/blue/x_twitter_bleu.svg';
import SelectEnableTrigger from "../form/parts/SelectEnableTrigger.js";

export const FORM_SECTIONS = {
    PERIOD_TIMER: SelectPeriodTimer,
    TITLE_COMMENT: SelectTitleComment,
    TEAM: SelectTeam,
    PLAYER: SelectPlayer,
    CUSTO: SelectCusto,
    PIN: CheckPin,
    TAGS: SelectTags,
    NOTATION : SelectNotation,
    SURVEY_QUESTION: SelectSurveyQuestion,
    SURVEY_CHOICES: SelectSurveyChoices,
    SURVEY_OPTIONS: SelectSurveyOptions,
    QUIZZ_QUESTION: SelectQuizzQuestion,
    QUIZZ_CHOICES: SelectQuizzChoices,
    QUIZZ_OPTIONS: SelectQuizzOptions,
    QUILL_EDITOR: EditorQuill,
    QUESTIONBOX_LABEL: SelectQuestionBoxLabel,
    PREVIEW: Preview,
    ENABLE_TRIGGER: SelectEnableTrigger,
  };

const gameEventsByDiscipline = {
    soccer: [
      { type: GAME_FACT_SOCCER_BUT, label: "BUT", img: but_img, picto: { standard: picto_but, blue: picto_but_blue }, subscription : 4 },
      { type: GAME_FACT_SOCCER_PENALTY, label: "PENALTY", img: penalty_img, picto: { standard: picto_penalty, blue: picto_penalty_blue },subscription : 2 },
      { type: GAME_FACT_SOCCER_SHOT, label: "TIR", img: tir_img, picto: { standard: picto_tir, blue: picto_tir_blue },subscription : 2 },
      { type: GAME_FACT_SOCCER_FAULT, label: "FAUTE", img: soccer_fault_img, picto: { standard: picto_faute, blue: picto_faute_blue }, subscription : 2 },
      { type: GAME_FACT_SOCCER_YELLOWCARD, label: "CARTON JAUNE", img: yellow_img, picto: { standard: picto_carton_jaune, blue: picto_carton_jaune_blue }, subscription : 2 },
      { type: GAME_FACT_SOCCER_REDCARD, label: "CARTON ROUGE", img: red_img, picto: { standard: picto_carton_rouge, blue: picto_carton_rouge_blue },subscription : 3 },
      { type: GAME_FACT_SOCCER_REPLACEMENT, label: "CHANGEMENT", img: changement_img, picto: { standard: picto_changement, blue: picto_changement_blue }, subscription : 2 },
      { type: GAME_FACT_SOCCER_STAR, label: "ETOILE", img: star_img, picto: { standard: picto_etoile, blue: picto_etoile_blue }, subscription : 3 },
      { type: GAME_FACT_SOCCER_COMMENT, label: "COMMENTAIRE", img: commentaire_img, picto: { standard: picto_commentaire, blue: picto_commentaire_blue }, subscription : 2 },
      { type: GAME_FACT_SOCCER_SHOOTOUTPENALTY, label: "TIR AU BUT", img: soccer_tiraubut_img, picto: { standard: picto_tir, blue: picto_tir_blue }, subscription : 2 },
    ],
    rugby: [
      { type: GAME_FACT_ESSAI, label: "ESSAI", img: essai_img, picto: { standard: picto_essai, blue: picto_essai_blue }, subscription : 4 },
      { type: GAME_FACT_TRANSFORMATION, label: "TRANSFORMATION", img: transformation_img, picto: { standard: picto_transformation_rugby, blue: picto_transformation_rugby_blue }, subscription : 4 },
      { type: GAME_FACT_DROP, label: "DROP", img: drop_img, picto: { standard: picto_drop, blue: picto_drop_blue }, subscription : 4 },
      { type: GAME_FACT_PENALITE, label: "PENALITE", img: penalite_img, picto: { standard: picto_penality_rugby, blue: picto_penality_rugby_blue }, subscription : 4 },
      { type: GAME_FACT_FAULT, label: "FAUTE", img: soccer_fault_img, picto: { standard: picto_faute, blue: picto_faute_blue }, subscription : 2 },
      { type: GAME_FACT_YELLOWCARD, label: "CARTON JAUNE", img: yellow_img, picto: { standard: picto_carton_jaune, blue: picto_carton_jaune_blue },subscription : 2 },
      { type: GAME_FACT_REDCARD, label: "CARTON ROUGE", img: red_img, picto: { standard: picto_carton_rouge, blue: picto_carton_rouge_blue }, subscription : 3 },
      { type: GAME_FACT_REPLACEMENT, label: "CHANGEMENT", img: changement_img, picto: { standard: picto_changement, blue: picto_changement_blue }, subscription : 2 },
      { type: GAME_FACT_RUGBY_STAR, label: "ETOILE", img: star_img, picto: { standard: picto_etoile, blue: picto_etoile_blue }, subscription : 3 },
      { type: GAME_FACT_COMMENT, label: "COMMENTAIRE", img: commentaire_img, picto: { standard: picto_commentaire, blue: picto_commentaire_blue }, subscription : 2 },
      { type: GAME_FACT_SHOOTOUTPENALTY, label: "TIR AU BUT", img: penalite_img, picto: { standard: picto_tir_au_but_rugby, blue: picto_tir_au_but_rugby_blue }, subscription : 2 },
    ],
    handball: [
      { type: GAME_FACT_HANDBALL_GOAL, label: "BUT", img: but_hand_img, picto: { standard: picto_but_hand, blue: picto_but_hand_blue }, subscription : 4 },
      { type: GAME_FACT_HANDBALL_PENALTY, label: "PENALTY", img: penalty_hand_img, picto: { standard: picto_penalty, blue: picto_penalty_blue }, subscription : 2 },
      { type: GAME_FACT_HANDBALL_TIMEOUT, label: "TEMPS MORT", img: temps_mort_hand_img, picto: { standard: picto_temps_mort_hand, blue: picto_temps_mort_hand_blue }, subscription : 2 },
      { type: GAME_FACT_HANDBALL_TWOMIN_SUSPENSION, label: "2 MINUTES", img: exclusion_hand_img, picto: { standard: picto_exclusion, blue: picto_exclusion_blue }, subscription : 2 },
      { type: GAME_FACT_HANDBALL_YELLOWCARD, label: "CARTON JAUNE", img: yellow_img, picto: { standard: picto_carton_jaune, blue: picto_carton_jaune_blue }, subscription : 2 },
      { type: GAME_FACT_HANDBALL_REDCARD, label: "CARTON ROUGE", img: red_img, picto: { standard: picto_carton_rouge, blue: picto_carton_rouge_blue },subscription : 3 },
      { type: GAME_FACT_REPLACEMENT, label: "CHANGEMENT", img: changement_img, picto: { standard: picto_changement, blue: picto_changement_blue },subscription : 2 },
      { type: GAME_FACT_HANDBALL_TURNOVER, label: "BALLE PERDUE", img: balle_perdue_hand_img, picto: { standard: picto_balle_perdue, blue: picto_balle_perdue_blue }, subscription : 2 },
      { type: GAME_FACT_HANDBALL_SHOOTOUT, label: "TIR AU BUT", img: penalty_hand_img, picto: { standard: picto_tir_au_but_hand, blue: picto_tir_au_but_hand_blue }, subscription : 2 },
      { type: GAME_FACT_HANDBALL_STAR, label: "ETOILE", img: star_img, picto: { standard: picto_etoile, blue: picto_etoile_blue }, subscription : 3 },
      { type: GAME_FACT_COMMENT, label: "COMMENTAIRE", img: commentaire_img, picto: { standard: picto_commentaire, blue: picto_commentaire_blue }, subscription : 2 },
    ],
    basket: [
      { type: GAME_FACT_BASKET_FREETHROW, label: "LANCER FRANC", img: basket_lancer_franc_1pts_img, picto: { standard: picto_lancer_franc, blue: picto_lancer_franc_blue }, subscription : 4 },
      { type: GAME_FACT_BASKET_TWOPOINTS, label: "2 POINTS", img: basket_lancer_franc_2pts_img, picto: { standard: picto_2_pts, blue: picto_2_pts_blue }, subscription : 4 },
      { type: GAME_FACT_BASKET_THREEPOINTS, label: "3 POINTS", img: basket_lancer_franc_3pts_img, picto: { standard: picto_3_pts, blue: picto_3_pts_blue }, subscription : 4 },
      { type: GAME_FACT_BASKET_FAULT, label: "FAUTE", img: basket_faute_img, picto: { standard: picto_faute, blue: picto_faute_blue }, subscription : 2 },
      { type: GAME_FACT_BASKET_TECHNICAL, label: "TECHNIQUE", img: basket_faute_technique_img, picto: { standard: picto_faute_technique, blue: picto_faute_technique_blue }, subscription : 2 },
      { type: GAME_FACT_BASKET_TIMEOUT, label: "TEMPS MORT", img: basket_temps_mort_img, picto: { standard: picto_temps_mort_basket, blue: picto_temps_mort_basket_blue }, subscription : 2 },
      { type: GAME_FACT_BASKET_STAR, label: "ETOILE", img: star_img, picto: { standard: picto_etoile, blue: picto_etoile_blue }, subscription : 3 },
      { type: GAME_FACT_BASKET_COMMENT, label: "COMMENTAIRE", img: commentaire_img, picto: { standard: picto_commentaire, blue: picto_commentaire_blue }, subscription : 2 },
    ],
};

const importEvents = [
  { type: MEDIA_ARTICLE, label: "ARTICLE", picto: { standard: picto_article, blue: picto_article_blue }, subscription : 1 },
  { type: MEDIA_ARTICLE, label: "IMAGE", picto: { standard: picto_image, blue: picto_image_blue }, subscription : 1, options : {
                                                      onInit : { className : ".ql-image" }
                                                    } 
  },
  { type: MEDIA_ARTICLE, label: "TWEET", picto: { standard: picto_x_twitter, blue: picto_x_twitter_blue }, subscription : 1, options : {
                                                      onInit : { className : ".ql-twitter" }
                                                    }
  },
  { type: MEDIA_ARTICLE, label: "INSTAGRAM", picto: { standard: picto_instagram, blue: picto_instagram_blue }, subscription : 1, options : {
                                                      onInit : { className : ".ql-instagram" }
                                                    }
  },
  { type: MEDIA_ARTICLE, label: "FACEBOOK", picto: { standard: picto_fb, blue: picto_fb_blue }, subscription : 1, options : {
                                                      onInit : { className : ".ql-facebook" }
                                                    }
  },
  { type: MEDIA_ARTICLE, label: "IFRAME", picto: { standard: picto_iframe, blue: picto_iframe_blue }, subscription : 1, options : {
                                                      onInit : { className : ".ql-iframe" }
                                                    }
  },
  { type: MEDIA_SURVEY, label: "SONDAGE", picto: { standard: picto_sondage, blue: picto_sondage_blue }, subscription : 1 },
  { type: MEDIA_QUIZZ, label: "QUIZ", picto: { standard: picto_quiz, blue: picto_quiz_blue }, subscription : 1 },
  { type: MEDIA_NOTATION, label: "NOTATION", picto: { standard: picto_notation, blue: picto_notation_blue }, subscription : 1},
  { type: MEDIA_QUESTIONBOX, label: "BOÎTE À QUESTIONS", picto: { standard: picto_question_box, blue: picto_question_box_blue }, subscription : 1},
]

const periodEventsByDiscipline = {
  soccer: [
    { type: GAME_FACT_START, label: "DEBUT DE PERIODE" },
    { type: GAME_FACT_SOCCER_STOP, label: "FIN DE PERIODE" },
  ],
  rugby: [
    { type: GAME_FACT_START, label: "DEBUT DE PERIODE" },
    { type: GAME_FACT_RUGBY_STOP, label: "FIN DE PERIODE" },
  ],
  handball: [
    { type: GAME_FACT_START, label: "DEBUT DE PERIODE" },
    { type: GAME_FACT_HANDBALL_STOP, label: "FIN DE PERIODE" },
  ],
  basket: [
    { type: GAME_FACT_START, label: "DEBUT DE QUART TEMPS" },
    { type: GAME_FACT_BASKET_STOP, label: "FIN DE QUART TEMPS" },
  ]
}
  
  export const getGameEvents = (discipline) => {
    const gameFactsEvents = gameEventsByDiscipline[discipline] || []
    return [...gameFactsEvents, ...importEvents];
  };

  export const getPeriodEvents = (discipline) => {
    return periodEventsByDiscipline[discipline] || [];
  };

  export const formConfig = {
    [GAME_FACT_START]: {
      sections: [
        {   
            type: FORM_SECTIONS.TITLE_COMMENT, 
            key: "comment", 
        },
        {   
          type: FORM_SECTIONS.ENABLE_TRIGGER,
          // On n'affiche pas la section si l'event est en edition ou deja démarré
          hide : (event, match, checkSubscription) => event._id || match.period !== 0 || !checkSubscription(1)
        },
      ],
    },
    [GAME_FACT_SOCCER_STOP]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute de fin de période ?",
        },
        {   type: FORM_SECTIONS.CUSTO, 
            label: "Et ensuite ?", 
            key: "reason", 
            mandatory: true ,
            options: [
                { id: "next", label: "Periode suivante" },
                { id: "tab", label: "Séance de tirs au but" },
                { id: "end", label: "Fin de match" },
              ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
          key: "comment", 
        },
        {   
          type: FORM_SECTIONS.ENABLE_TRIGGER, 
          // On n'affiche pas la section si l'event est en edition
          hide : (event, match, checkSubscription) => event._id || !checkSubscription(1)
        },
      ],
    },
    [GAME_FACT_RUGBY_STOP]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute de fin de période ?",
        },
        {   type: FORM_SECTIONS.CUSTO, 
            label: "Et ensuite ?", 
            key: "reason", 
            mandatory: true ,
            options: [
                { id: "next", label: "Periode suivante" },
                { id: "tab", label: "Séance de tirs au but" },
                { id: "end", label: "Fin de match" },
              ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
          key: "comment", 
        },
        {   
          type: FORM_SECTIONS.ENABLE_TRIGGER, 
          // On n'affiche pas la section si l'event est en edition
          hide : (event, match, checkSubscription) => event._id || !checkSubscription(1)
        },
      ],
    },
    [GAME_FACT_HANDBALL_STOP]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute de fin de période ?",
        },
        {   type: FORM_SECTIONS.CUSTO, 
            label: "Et ensuite ?", 
            key: "reason", 
            mandatory: true ,
            options: [
                { id: "next", label: "Periode suivante" },
                { id: "tab", label: "Séance de tirs au but" },
                { id: "end", label: "Fin de match" },
              ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT,
          key: "comment",  
        },
        {   
          type: FORM_SECTIONS.ENABLE_TRIGGER, 
          // On n'affiche pas la section si l'event est en edition
          hide : (event, match, checkSubscription) => event._id || !checkSubscription(1)
        },
      ],
    },
    [GAME_FACT_BASKET_STOP]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute de fin de quart temps ?",
        },
        {   type: FORM_SECTIONS.CUSTO, 
            label: "Et ensuite ?", 
            key: "reason", 
            mandatory: true ,
            options: [
                { id: "next", label: "Periode suivante" },
                { id: "end", label: "Fin de match" },
              ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
          key: "comment", 
        },
        {   
          type: FORM_SECTIONS.ENABLE_TRIGGER, 
          // On n'affiche pas la section si l'event est en edition
          hide : (event, match, checkSubscription) => event._id || !checkSubscription(1)
        },
      ],
    },


    [GAME_FACT_SOCCER_BUT]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute du but ?",
        },
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe a marqué ?", 
            key: "team", 
            mandatory: true 
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur a marqué ?", 
            key: "buteur",
            custo: [
              {_id : 'csc', label : 'Contre son camps'}
            ]
        },
        {   
          type: FORM_SECTIONS.PLAYER, 
          label: "Quel joueur a fait une passe décisive ?", 
          key: "passeur",
        },
        {   type: FORM_SECTIONS.CUSTO, 
            label: "Le but est-il validé ?", 
            key: "butSucced", 
            mandatory: true ,
            options: [
                { id: true, label: "Oui" },
                { id: false, label: "Non" },
              ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
        {   
          type: FORM_SECTIONS.ENABLE_TRIGGER, 
          // On n'affiche pas la section si l'event est en edition
          hide : (event, match, checkSubscription) => event._id || !checkSubscription(1)
        },
      ],
    },
    [GAME_FACT_SOCCER_SHOOTOUTPENALTY]: {
      sections: [
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe effectue le tir au but ?", 
            key: "team", 
            mandatory: true 
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur effectue le tir au but ?", 
            key: "buteur", 
            mandatory: false 
        },
        {   type: FORM_SECTIONS.CUSTO, 
            label: "Le tir au but a-t-il été marqué ?", 
            key: "butSucced", 
            mandatory: true ,
            options: [
                { id: true, label: "Oui" },
                { id: false, label: "Non" },
              ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_SOCCER_PENALTY]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute du penalty ?",
        },
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe a tiré le penalty ?", 
            key: "team", 
            mandatory: true 
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur a tiré le penalty ?", 
            key: "buteur", 
            mandatory: false 
        },
        {   type: FORM_SECTIONS.CUSTO, 
            label: "Le penalty a-t-il été marqué ?", 
            key: "butSucced", 
            mandatory: true ,
            options: [
                { id: true, label: "Oui" },
                { id: false, label: "Non" },
              ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
        {   
          type: FORM_SECTIONS.ENABLE_TRIGGER, 
          // On n'affiche pas la section si l'event est en edition
          hide : (event, match, checkSubscription) => event._id || !checkSubscription(1)
        },
      ],
    },
    [GAME_FACT_SOCCER_FAULT]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute de la faute ?",
        },
        {   
            type: FORM_SECTIONS.TEAM,
            label: "Quelle équipe a fait la faute ?", 
            key: "team", 
            mandatory: true
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur a fait la faute ?", 
            key: "player",
        },
        {   
          type: FORM_SECTIONS.PLAYER,
          isFromOtherTeam : true, 
          label: "Quel joueur a subit la faute ?", 
          key: "opponent",
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_SOCCER_STAR]: {
      sections: [
        {   
          type: FORM_SECTIONS.PERIOD_TIMER, 
          label: "Quelle est la minute de l'étoile ?",
        },
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe a obtenu l'étoile ?", 
            key: "team", 
            mandatory: true
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur a obtenu l'étoile ?", 
            key: "player",
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_SOCCER_SHOT]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute du tir ?",
        },
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe a tiré ?", 
            key: "team", 
            mandatory: true 
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur a tiré ?", 
            key: "shoter", 
        },
        {   type: FORM_SECTIONS.CUSTO, 
            label: "Qualité du tir ?", 
            key: "reason", 
            options: [
              {id : 'cadre', label : `Cadré`},
              {id : 'nocadre', label : `Non cadré`},
              {id : 'poteau', label : `Poteaux`},
              {id : 'transversale', label : `Barre transversale`},
              ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_SOCCER_YELLOWCARD]: {
      sections: [
        {   type: FORM_SECTIONS.PERIOD_TIMER, 
        },
        {   type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe prend un carton jaune ?", 
            key: "team", 
            mandatory: true 
        },
        {   type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur prend un carton jaune ?", 
            key: "player",  
            custo : [
              {_id : 'coach', label : 'Entraineur'}
            ]
        },
        {   type: FORM_SECTIONS.CUSTO, 
          label: "Pour quelle raison ?", 
          key: "reason", 
          options: [
            {id : 'faute', label : `Faute`},
            {id : 'contestation', label : `Contestation`},
            {id : 'simulation', label : `Simulation`},
            {id : 'gaintemps', label : `Gain de temps`},
            {id : 'autres', label : `Autres`},
            ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_SOCCER_SECONDYELLOWCARD]: {
      sections: [
        {   type: FORM_SECTIONS.PERIOD_TIMER, 
        },
        {   type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe prend un carton jaune ?", 
            key: "team", 
            mandatory: true 
        },
        {   type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur prend un carton jaune ?", 
            key: "player",  
            custo : [
              {_id : 'coach', label : 'Entraineur'}
            ]
        },
        {   type: FORM_SECTIONS.CUSTO, 
          label: "Pour quelle raison ?", 
          key: "reason", 
          options: [
            {id : 'faute', label : `Faute`},
            {id : 'contestation', label : `Contestation`},
            {id : 'simulation', label : `Simulation`},
            {id : 'gaintemps', label : `Gain de temps`},
            {id : 'autres', label : `Autres`},
            ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_SOCCER_REDCARD]: {
      sections: [
        {   type: FORM_SECTIONS.PERIOD_TIMER, 
        },
        {   type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe prend un carton rouge ?", 
            key: "team", 
            mandatory: true
        },
        {   type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur prend un carton rouge ?", 
            key: "player",
            custo : [
              {_id : 'coach', label : 'Entraineur'}
            ] 
        },
        {   type: FORM_SECTIONS.CUSTO, 
          label: "Pour quelle raison ?", 
          key: "reason", 
          options: [
            {id : 'lastdef', label : `Dernier défenseur`},
            {id : 'dangerous', label : `Faute dangereuse`},
            {id : 'autres', label : `Autres`},
            ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
        {   
          type: FORM_SECTIONS.ENABLE_TRIGGER, 
          // On n'affiche pas la section si l'event est en edition
          hide : (event, match, checkSubscription) => event._id || !checkSubscription(1)
        },
      ],
    },
    [GAME_FACT_SOCCER_REPLACEMENT]: {
      sections: [
        {   type: FORM_SECTIONS.PERIOD_TIMER, 
        },
        {   type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe effectue un changement ?", 
            key: "team", 
            mandatory: true
        },
        {   type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur sort du terrain ?", 
            key: "outplayer",
        },
         {   type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur rentre sur le terrain ?", 
            key: "inplayer",
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
        {   
          type: FORM_SECTIONS.ENABLE_TRIGGER, 
          // On n'affiche pas la section si l'event est en edition
          hide : (event, match, checkSubscription) => event._id || !checkSubscription(1)
        },
      ],
    },
    [GAME_FACT_SOCCER_COMMENT]: {
      sections: [
        {   type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute de votre commentaire ?" 
        },
        {   type: FORM_SECTIONS.TEAM, 
            label: "Quelle est la cible du commentaire ?", 
            key: "target", 
            mandatory: true,
            custo : [
              {_id : 'other', label : 'Autre'}
            ]
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT,
          key: "comment", 
        },
      ],
    },


    [GAME_FACT_ESSAI]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute de l\'essai ?",
        },
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe a mis l'essai ?", 
            key: "team", 
            mandatory: true 
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur a mis l'essai ?", 
            key: "buteur",
            custo: [
              {_id : 'edp', label : 'Essai de pénalité'}
            ]
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_TRANSFORMATION]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute de la transformation ?",
        },
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe a transformé ?", 
            key: "team", 
            mandatory: true 
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur a transformé ?", 
            key: "transformer"
        },
        {   type: FORM_SECTIONS.CUSTO, 
            label: "La transformation a-t-elle été réussie ?", 
            key: "transformSucced", 
            mandatory: true ,
            options: [
                { id: true, label: "Oui" },
                { id: false, label: "Non" },
              ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_DROP]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute du drop ?",
        },
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe tente le drop ?", 
            key: "team", 
            mandatory: true 
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur tente le drop ?", 
            key: "droper"
        },
        {   type: FORM_SECTIONS.CUSTO, 
            label: "Le drop a-t-il été réussi ?", 
            key: "dropSucced", 
            mandatory: true ,
            options: [
                { id: true, label: "Oui" },
                { id: false, label: "Non" },
              ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_PENALITE]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute de la pénalité?",
        },
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe tente la pénalité ?", 
            key: "team", 
            mandatory: true 
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur tente la pénalité ?", 
            key: "penaliter"
        },
        {   type: FORM_SECTIONS.CUSTO, 
            label: "La pénalité a-t-elle été réussie ?", 
            key: "penalitySucced", 
            mandatory: true ,
            options: [
                { id: true, label: "Oui" },
                { id: false, label: "Non" },
              ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_SHOOTOUTPENALTY]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute du tir au but?",
        },
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe tir au but ?", 
            key: "team", 
            mandatory: true 
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur tir au but ?", 
            key: "penaliter"
        },
        {   type: FORM_SECTIONS.CUSTO, 
            label: "Le tir au but a-t-il été réussi ?", 
            key: "penalitySucced", 
            mandatory: true ,
            options: [
                { id: true, label: "Oui" },
                { id: false, label: "Non" },
              ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_YELLOWCARD]: {
      sections: [
        {   type: FORM_SECTIONS.PERIOD_TIMER, 
        },
        {   type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe prend un carton jaune ?", 
            key: "team", 
            mandatory: true 
        },
        {   type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur prend un carton jaune ?", 
            key: "player",  
            custo : [
              {_id : 'coach', label : 'Entraineur'}
            ]
        },
        {   type: FORM_SECTIONS.CUSTO, 
          label: "Pour quelle raison ?", 
          key: "reason", 
          options: [
            {id : 'horsjeu', label : `Hors jeux`},
            {id : 'maulecroule', label : `Maul écroulé`},
            {id : 'meleeecroule', label : `Mêlée écroulée`},
            {id : 'plaquageanticipe', label : `Plaquage anticipé`},
            {id : 'tenirleballon', label : `Tenir le ballon`},
            {id : 'jeudeloyal', label : `Jeu déloyal`},
            {id : 'autres', label : `Autres`},
            ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_REDCARD]: {
      sections: [
        {   type: FORM_SECTIONS.PERIOD_TIMER, 
        },
        {   type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe prend un carton rouge ?", 
            key: "team", 
            mandatory: true
        },
        {   type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur prend un carton rouge ?", 
            key: "player",
            custo : [
              {_id : 'coach', label : 'Entraineur'}
            ] 
        },
        {   type: FORM_SECTIONS.CUSTO, 
          label: "Pour quelle raison ?", 
          key: "reason", 
          options: [
            {id : 'horsjeu', label : `Hors jeux`},
            {id : 'maulecroule', label : `Maul écroulé`},
            {id : 'meleeecroule', label : `Mêlée écroulée`},
            {id : 'plaquageanticipe', label : `Plaquage anticipé`},
            {id : 'tenirleballon', label : `Tenir le ballon`},
            {id : 'jeudeloyal', label : `Jeu déloyal`},
            {id : 'autres', label : `Autres`},
            ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
        {   
          type: FORM_SECTIONS.ENABLE_TRIGGER, 
          // On n'affiche pas la section si l'event est en edition
          hide : (event, match, checkSubscription) => event._id || !checkSubscription(1)
        },
      ],
    },
    [GAME_FACT_FAULT]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute de la faute ?",
        },
        {   
            type: FORM_SECTIONS.TEAM,
            label: "Quelle équipe a fait la faute ?", 
            key: "team", 
            mandatory: true
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur a fait la faute ?", 
            key: "player",
        },
        {   type: FORM_SECTIONS.CUSTO, 
          label: "Pour quelle raison ?", 
          key: "reason", 
          options: [
            {id : 'horsjeu', label : `Hors jeux`},
            {id : 'maulecroule', label : `Maul écroulé`},
            {id : 'meleeecroule', label : `Mêlée écroulée`},
            {id : 'plaquageanticipe', label : `Plaquage anticipé`},
            {id : 'tenirleballon', label : `Tenir le ballon`},
            {id : 'jeudeloyal', label : `Jeu déloyal`},
            {id : 'autres', label : `Autres`},
            ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_REPLACEMENT]: {
      sections: [
        {   type: FORM_SECTIONS.PERIOD_TIMER, 
        },
        {   type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe effectue un changement ?", 
            key: "team", 
            mandatory: true
        },
        {   type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur sort du terrain ?", 
            key: "outplayer",
        },
        {   type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur rentre sur le terrain ?", 
            key: "inplayer",
        },
        {   type: FORM_SECTIONS.CUSTO, 
          label: "Pour quelle raison ?", 
          key: "reason", 
          options: [
            {id : 'normal', label : `Normal`},
            {id : 'blessure', label : `Blessure`},
            {id : 'tactique', label : `Tactique`},
            ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
        {   
          type: FORM_SECTIONS.ENABLE_TRIGGER, 
          // On n'affiche pas la section si l'event est en edition
          hide : (event, match, checkSubscription) => event._id || !checkSubscription(1)
        },
      ],
    },
    [GAME_FACT_RUGBY_STAR]: {
      sections: [
        {   
          type: FORM_SECTIONS.PERIOD_TIMER, 
          label: "Quelle est la minute de l'étoile ?",
        },
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe a obtenu l'étoile ?", 
            key: "team", 
            mandatory: true
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur a obtenu l'étoile ?", 
            key: "player",
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_COMMENT]: {
      sections: [
        {   type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute de votre commentaire ?" 
        },
        {   type: FORM_SECTIONS.TEAM, 
            label: "Quelle est la cible du commentaire ?", 
            key: "team", 
            mandatory: true,
            custo : [
              {_id : 'other', label : 'Autre'}
            ]
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
          key: "comment", 
        },
      ],
    },

    [GAME_FACT_HANDBALL_GOAL]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute du but ?",
        },
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe a marqué ?", 
            key: "team", 
            mandatory: true 
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur a marqué ?", 
            key: "buteur",
        },
        {   type: FORM_SECTIONS.CUSTO, 
            label: "Le but est-il validé ?", 
            key: "butSucced", 
            mandatory: true ,
            options: [
                { id: true, label: "Oui" },
                { id: false, label: "Non" },
              ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
        {   
          type: FORM_SECTIONS.ENABLE_TRIGGER, 
          // On n'affiche pas la section si l'event est en edition
          hide : (event, match, checkSubscription) => event._id || !checkSubscription(1)
        },
      ],
    },
    [GAME_FACT_HANDBALL_PENALTY]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute du penalty ?",
        },
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe a tiré le penalty ?", 
            key: "team", 
            mandatory: true 
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur a tiré le penalty ?", 
            key: "penaliter", 
            mandatory: false 
        },
        {   type: FORM_SECTIONS.CUSTO, 
            label: "Le penalty est-il validé ?", 
            key: "penalitySucced", 
            mandatory: true ,
            options: [
                { id: true, label: "Oui" },
                { id: false, label: "Non" },
              ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
        {   
          type: FORM_SECTIONS.ENABLE_TRIGGER, 
          // On n'affiche pas la section si l'event est en edition
          hide : (event, match, checkSubscription) => event._id || !checkSubscription(1)
        },
      ],
    },
    [GAME_FACT_HANDBALL_SHOOTOUT]: {
      sections: [
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe effectue le tir au but ?", 
            key: "team", 
            mandatory: true 
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur effectue le tir au but ?", 
            key: "buteur", 
            mandatory: false 
        },
        {   type: FORM_SECTIONS.CUSTO, 
            label: "Le but est-il validé ?", 
            key: "butSucced", 
            mandatory: true ,
            options: [
                { id: true, label: "Oui" },
                { id: false, label: "Non" },
              ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_HANDBALL_YELLOWCARD]: {
      sections: [
        {   type: FORM_SECTIONS.PERIOD_TIMER, 
        },
        {   type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe reçoit un avertissement ?", 
            key: "team", 
            mandatory: true 
        },
        {   type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur reçoit un avertissement ?", 
            key: "player",  
            custo : [
              {_id : 'coach', label : 'Entraineur'}
            ]
        },
        {   type: FORM_SECTIONS.CUSTO, 
          label: "Pour quelle raison ?", 
          key: "reason", 
          options: [
            {id: 'minorFoul', label: `Faute mineure`},
            {id: 'unsportingBehavior', label: `Comportement antisportif`},
            {id: 'dangerousPlay', label: `Jeu dangereux`},
            {id: 'autres', label: `Autres`}
          ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_HANDBALL_REDCARD]: {
      sections: [
        {   type: FORM_SECTIONS.PERIOD_TIMER, 
        },
        {   type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe reçoit une disqualification ?", 
            key: "team", 
            mandatory: true
        },
        {   type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur reçoit une disqualification ?", 
            key: "player",
            custo : [
              {_id : 'coach', label : 'Entraineur'}
            ] 
        },
        {   type: FORM_SECTIONS.CUSTO, 
          label: "Pour quelle raison ?", 
          key: "reason", 
          options: [
            {id: 'severeFoul', label: `Faute grave`},
            {id: 'violentConduct', label: `Conduite violente`},
            {id: 'threeTwoMinSuspensions', label: `Trois exclusions temporaires`},
            {id: 'autres', label: `Autres`},
            ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_HANDBALL_TWOMIN_SUSPENSION]: {
      sections: [
        {   type: FORM_SECTIONS.PERIOD_TIMER, 
        },
        {   type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe reçoit une exclusion ?", 
            key: "team", 
            mandatory: true
        },
        {   type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur reçoit une exclusion ?", 
            key: "player",
        },
        {   type: FORM_SECTIONS.CUSTO, 
          label: "Pour quelle raison ?", 
          key: "reason", 
          options: [
            {id: 'repeatedFouls', label: `Fautes répétées`},
            {id: 'unsportingBehavior', label: `Comportement antisportif`},
            {id: 'dangerousPlay', label: `Jeu dangereux`},
            {id: 'autres', label: `Autres`},
            ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_HANDBALL_TIMEOUT]: {
      sections: [
        {   type: FORM_SECTIONS.PERIOD_TIMER, 
        },
        {   type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe prend un temps mort ?", 
            key: "team", 
            mandatory: true
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_HANDBALL_TURNOVER]: {
      sections: [
        {   type: FORM_SECTIONS.PERIOD_TIMER, 
        },
        {   type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe a perdu la balle ?", 
            key: "team", 
            mandatory: true
        },
        {   type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur a perdu la balle ?", 
            key: "player",
        },
        {   type: FORM_SECTIONS.CUSTO, 
          label: "Quelle est la raison de la perte de balle ?", 
          key: "reason", 
          options: [
            {id: 'badPass', label: `Mauvaise passe`},
            {id: 'interception', label: `Interception par l'adversaire`},
            {id: 'footFault', label: `Faute de pied`},
            {id: 'traveling', label: `Marcher avec la balle`},
            {id: 'doubleDribble', label: `Double dribble`},
            {id: 'offensiveFoul', label: `Faute offensive`},
            {id: 'ballOutOfBounds', label: `Balle sortie des limites`},
            {id: 'autres', label: `Autres`},
            ],
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_HANDBALL_STAR]: {
      sections: [
        {   
          type: FORM_SECTIONS.PERIOD_TIMER, 
          label: "Quelle est la minute de l'étoile ?",
        },
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe a obtenu l'étoile ?", 
            key: "team", 
            mandatory: true
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur a obtenu l'étoile ?", 
            key: "player",
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },

    [GAME_FACT_BASKET_FREETHROW]: {
      sections: [
        {   
          type: FORM_SECTIONS.PERIOD_TIMER, 
          label: "Quelle est la minute du lancer franc ?",
        },
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe tir lancer franc ?", 
            key: "team", 
            mandatory: true 
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur tir lancer franc ?", 
            key: "player",
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_BASKET_TWOPOINTS]: {
      sections: [
        {   
          type: FORM_SECTIONS.PERIOD_TIMER, 
          label: "Quelle est la minute du 2 points ?",
        },
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe tir deux points ?", 
            key: "team", 
            mandatory: true 
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur tir deux points ?", 
            key: "player",
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_BASKET_THREEPOINTS]: {
      sections: [
        {   
          type: FORM_SECTIONS.PERIOD_TIMER, 
          label: "Quelle est la minute du 3 points ?",
        },
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe tir trois points ?", 
            key: "team", 
            mandatory: true 
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur tir trois points ?", 
            key: "player",
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_BASKET_FAULT]: {
      sections: [
        {   
          type: FORM_SECTIONS.PERIOD_TIMER, 
          label: "Quelle est la minute de la faute ?",
        },
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe fait une faute ?", 
            key: "team", 
            mandatory: true 
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur fait une faute ?", 
            key: "player",
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_BASKET_TECHNICAL]: {
      sections: [
        {   
          type: FORM_SECTIONS.PERIOD_TIMER, 
          label: "Quelle est la minute de la faute technique ?",
        },
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe fait une faute technique ?", 
            key: "team", 
            mandatory: true 
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur fait une faute technique ?", 
            key: "player",
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_BASKET_COMMENT]: {
      sections: [
        {   
          type: FORM_SECTIONS.PERIOD_TIMER, 
          label: "Quelle est la minute du commentaire ?",
        },
        {   type: FORM_SECTIONS.TEAM, 
            label: "Quelle est la cible du commentaire ?", 
            key: "team", 
            mandatory: true,
            custo : [
              {_id : 'other', label : 'Autre'}
            ]
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
          key: "comment", 
        },
      ],
    },
    [GAME_FACT_BASKET_TIMEOUT]: {
      sections: [
        {   
          type: FORM_SECTIONS.PERIOD_TIMER, 
          label: "Quelle est la minute du temps mort ?",
        },
        {   type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe prend un temps mort ?", 
            key: "team", 
            mandatory: true
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },
    [GAME_FACT_BASKET_STAR]: {
      sections: [
        {   
          type: FORM_SECTIONS.PERIOD_TIMER, 
          label: "Quelle est la minute de l'étoile ?",
        },
        {   
            type: FORM_SECTIONS.TEAM, 
            label: "Quelle équipe a obtenu l'étoile ?", 
            key: "team", 
            mandatory: true
        },
        {   
            type: FORM_SECTIONS.PLAYER, 
            label: "Quel joueur a obtenu l'étoile ?", 
            key: "player",
        },
        {   
          type: FORM_SECTIONS.TITLE_COMMENT, 
        },
      ],
    },

    [MEDIA_NOTATION]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute de la notation ?",
            scale : 60
        },
        {   
            type: FORM_SECTIONS.PIN, 
        },
        {   
          type: FORM_SECTIONS.TAGS, 
        },
        {   
          type: FORM_SECTIONS.NOTATION,
          mandatory: true,
          checkValidation : (event) => event.customQuestion || event.globalTarget
        },
        {
          type: FORM_SECTIONS.PREVIEW
        }
      ]
    },
    [MEDIA_SURVEY]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute du sondage ?",
            scale : 60
        },
        {   
            type: FORM_SECTIONS.PIN, 
        },
        {   
          type: FORM_SECTIONS.TAGS, 
        },
        {   
          type: FORM_SECTIONS.SURVEY_QUESTION,
          key : 'question',
          mandatory: true
        },
        {   
          type: FORM_SECTIONS.SURVEY_OPTIONS,
          key : 'options',
          mandatory: true
        },
        {   
          type: FORM_SECTIONS.SURVEY_CHOICES,
          key : 'choices',
          mandatory: true,
          checkValidation : (event) => {
            if (!event.choices || !event.choices.length) return false;

            return event.choices.every(choice => {
              const entries = choice.entries;
              if (!entries || !entries.length) return false;

              const allEntriesValid = entries.every(entry => !!entry.name && entry.name.trim() !== '');

              if (entries.length > 1) {
                return !!choice.label && choice.label.trim() !== '' && allEntriesValid;
              } else {
                return allEntriesValid;
              }
            });
          }
        },
        {
          type: FORM_SECTIONS.PREVIEW
        }
      ]
    },
    [MEDIA_QUIZZ]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute de votre quiz ?",
            scale : 60
        },
        {   
            type: FORM_SECTIONS.PIN, 
        },
        {   
          type: FORM_SECTIONS.TAGS, 
        },
        {   
          type: FORM_SECTIONS.QUIZZ_QUESTION,
          key : 'question',
          mandatory: true
        },
        {   
          type: FORM_SECTIONS.QUIZZ_OPTIONS,
          key : 'options',
          mandatory: true
        },
        {   
          type: FORM_SECTIONS.QUIZZ_CHOICES,
          key : 'choices',
          mandatory: true,
          checkValidation : (event) => {
            if (!event.choices || !event.choices.length) return false;

            return event.choices.every(choice => {
              const entries = choice.entries;
              if (!entries || !entries.length) return false;

              const allEntriesValid = entries.every(entry => !!entry.name && entry.name.trim() !== '');

              if (entries.length > 1) {
                return !!choice.label && choice.label.trim() !== '' && allEntriesValid;
              } else {
                return allEntriesValid;
              }
            });
          }
        },
        {
          type: FORM_SECTIONS.PREVIEW
        }
      ]
    },
    [MEDIA_QUESTIONBOX]: {
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute de votre boite à questions ?",
            scale : 60
        },
        {   
            type: FORM_SECTIONS.PIN, 
        },
        {   
          type: FORM_SECTIONS.TAGS, 
        },
        {   
          type: FORM_SECTIONS.QUESTIONBOX_LABEL,
          key : 'title',
          mandatory: true
        },
        {
          type: FORM_SECTIONS.PREVIEW
        }
      ]
    },
    [MEDIA_ARTICLE]: {
      options: {
        mode : 'media',
      },
      sections: [
        {   
            type: FORM_SECTIONS.PERIOD_TIMER, 
            label: "Quelle est la minute de votre article ?",
            scale : 60
        },
        {   
            type: FORM_SECTIONS.PIN, 
        },
        {   
          type: FORM_SECTIONS.TAGS, 
        },
        {   
          type: FORM_SECTIONS.QUILL_EDITOR,
          width : FULL_WIDTH
        },
      ],
      onInit : (options) => {
        if(!options)
          return
        
        const {className} = options

        if(!className)
          return

        const imageButton = document.querySelector(className); // Sélection du bouton
          if (imageButton) {
            imageButton.click(); // Simulation du clic
          }
      }
    }
  };
  
  export const getFormConfig = (gameEventId) => {
    return formConfig[gameEventId];
  };